/**
 * BottomControlPanel - EXACT PORT dari ModelViewerBACKUP.jsx
 * Line 16872-18742 dari backup file
 * 100% SAMA - NO SIMPLIFICATION
 */

import React from 'react'

export default function BottomControlPanelFull(props) {
  const {
    // Display controls
    showPanel,
    viewportReady,
    isAnimationPanelOpen,
    setIsAnimationPanelOpen,
    isMobile,
    isReady,
    modelFile,
    modelUrlProp,
    
    // Animation data
    animations = [],
    selectedAnimation,
    setSelectedAnimation,
    
    // Playback controls
    isPlaying,
    setIsPlaying,
    restartAnimation,
    animationSpeed,
    setAnimationSpeed,
    animationProgress,
    animationDuration,
    seekAnimation,
    isDraggingProgressRef,
    currentActionRef,
    
    // Recording
    isRecording,
    isRendering,
    renderProgress,
    recordingMode,
    setRecordingMode,
    startRecording,
    stopRecording,
    cancelRendering,
    transparentBackground,
    
    // Screenshot
    captureScreenshot,
    
    // Camera Animation
    cameraKeyframes = [],
    setCameraKeyframes,
    cameraKeyframesRef,
    isRecordingCameraAnimation,
    setIsRecordingCameraAnimation,
    selectedCameraKeyframe,
    setSelectedCameraKeyframe,
    flashKeyframe,
    setFlashKeyframe,
    cameraInterpolationType,
    setCameraInterpolationType,
    cameraAnimationDuration,
    cameraRef,
    controlsRef,
    showCameraAnimToast,
    addCameraKeyframe,
    updateCameraKeyframe,
    deleteCameraKeyframe,
  } = props

  if (!showPanel || !viewportReady) return null

  return (
    <>
      {/* Compact Control Panel - Bottom (Music Player Style) */}
      {isAnimationPanelOpen && (
        <div
          style={{
            position: "absolute",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 15,
            minWidth: isMobile ? "calc(100% - 40px)" : "700px",
            maxWidth: isMobile ? "calc(100% - 40px)" : "900px",
            background:
              "linear-gradient(135deg, rgba(20, 20, 30, 0.72) 0%, rgba(10, 10, 15, 0.78) 100%)",
            backdropFilter: "blur(24px) saturate(190%)",
            WebkitBackdropFilter: "blur(24px) saturate(190%)",
            borderRadius: "16px",
            padding: isMobile ? "12px 16px" : "14px 20px",
            boxShadow:
              "0 8px 24px rgba(0, 0, 0, 0.15), 0 16px 48px rgba(0, 0, 0, 0.12)",
            fontFamily: "system-ui, -apple-system, sans-serif",
            border: "0.5px solid rgba(255, 255, 255, 0.18)",
            borderTop: "0.5px solid rgba(255, 255, 255, 0.25)",
            animation:
              "slideInFromBottom 0.5s cubic-bezier(0.32, 0.72, 0, 1) 0.3s forwards",
            opacity: 0,
            userSelect: "none",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
          }}
        >
          {/* Main Control Row */}
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              alignItems: isMobile ? "stretch" : "center",
              gap: isMobile ? "10px" : "12px",
              marginBottom:
                animations.length > 0 && selectedAnimation ? "10px" : "0",
            }}
          >
            {/* Compact Controls for Mobile - Single Row */}
            {isMobile && animations.length > 0 && selectedAnimation && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={restartAnimation}
                  style={{
                    width: "36px",
                    height: "36px",
                    backgroundColor: "#374151",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s",
                  }}
                  title="Restart"
                >
                  ↻
                </button>

                <button
                  onClick={() => setIsPlaying(!isPlaying)}
                  style={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: isPlaying ? "#10b981" : "#3b82f6",
                    color: "#fff",
                    border: "none",
                    borderRadius: "50%",
                    cursor: "pointer",
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s",
                    boxShadow: "0 2px 12px rgba(59, 130, 246, 0.4)",
                  }}
                >
                  {isPlaying ? "⏸" : "▶"}
                </button>

                {/* Speed Toggle */}
                <button
                  onClick={() => {
                    const speeds = [1, 2, 5, 10]
                    const currentIndex = speeds.indexOf(animationSpeed)
                    const nextIndex = (currentIndex + 1) % speeds.length
                    setAnimationSpeed(speeds[nextIndex])
                  }}
                  style={{
                    padding: "8px 10px",
                    backgroundColor: "#374151",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "11px",
                    fontWeight: 600,
                    transition: "all 0.2s",
                  }}
                  title="Cycle Speed"
                >
                  {animationSpeed}x
                </button>

                {/* Screenshot Icon Button */}
                <button
                  onClick={captureScreenshot}
                  style={{
                    width: "36px",
                    height: "36px",
                    backgroundColor: "#3b82f6",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s",
                    boxShadow: "0 2px 8px rgba(59, 130, 246, 0.3)",
                  }}
                  title="Screenshot"
                >
                  📸
                </button>

                {/* Recording Mode Toggle */}
                <button
                  onClick={() =>
                    setRecordingMode(
                      recordingMode === "real-time"
                        ? "high-quality"
                        : "real-time"
                    )
                  }
                  disabled={isRecording || isRendering}
                  style={{
                    padding: "0 8px",
                    height: "36px",
                    backgroundColor:
                      recordingMode === "high-quality" ? "#10b981" : "#6366f1",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: isRecording || isRendering ? "not-allowed" : "pointer",
                    fontSize: "10px",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    transition: "all 0.2s",
                    opacity: isRecording || isRendering ? 0.5 : 1,
                  }}
                  title={
                    recordingMode === "high-quality"
                      ? "High Quality Mode (Custom FPS & Duration)"
                      : "Real-time Mode (Faster, May Lag)"
                  }
                >
                  {recordingMode === "high-quality" ? "⚡HQ" : "⏱️RT"}
                </button>

                {/* Record Icon Button */}
                <button
                  onClick={
                    isRendering
                      ? cancelRendering
                      : isRecording
                        ? stopRecording
                        : startRecording
                  }
                  disabled={
                    (!selectedAnimation && !isRecording && !isRendering) ||
                    transparentBackground
                  }
                  style={{
                    width: "36px",
                    height: "36px",
                    backgroundColor: isRendering
                      ? "#8b5cf6"
                      : isRecording
                        ? "#ef4444"
                        : !selectedAnimation || transparentBackground
                          ? "#4b5563"
                          : "#f59e0b",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor:
                      (!selectedAnimation && !isRecording && !isRendering) ||
                      transparentBackground
                        ? "not-allowed"
                        : "pointer",
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s",
                    opacity:
                      (!selectedAnimation && !isRecording && !isRendering) ||
                      transparentBackground
                        ? 0.5
                        : 1,
                    boxShadow: isRendering
                      ? "0 2px 8px rgba(139, 92, 246, 0.4)"
                      : isRecording
                        ? "0 2px 8px rgba(239, 68, 68, 0.4)"
                        : !selectedAnimation
                          ? "none"
                          : "0 2px 8px rgba(245, 158, 11, 0.3)",
                  }}
                  title={
                    transparentBackground
                      ? "Video recording disabled - WebM doesn't support transparent background"
                      : isRendering
                        ? "Cancel Rendering"
                        : isRecording
                          ? "Stop Recording"
                          : "Record Animation"
                  }
                >
                  {isRendering ? "⏸" : isRecording ? "⏹" : "🎥"}
                </button>

                {/* Hide Panel Button */}
                <button
                  onClick={() => setIsAnimationPanelOpen(false)}
                  style={{
                    width: "36px",
                    height: "36px",
                    backgroundColor: "rgba(239, 68, 68, 0.2)",
                    color: "#ef4444",
                    border: "1px solid rgba(239, 68, 68, 0.3)",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s",
                  }}
                  title="Hide Panel"
                >
                  ✕
                </button>
              </div>
            )}

            {/* Mobile - No Animation Case */}
            {isMobile && (animations.length === 0 || !selectedAnimation) && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  justifyContent: "center",
                }}
              >
                {/* Screenshot Icon Button */}
                <button
                  onClick={captureScreenshot}
                  style={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#3b82f6",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s",
                    boxShadow: "0 2px 8px rgba(59, 130, 246, 0.3)",
                  }}
                  title="Screenshot"
                >
                  📸
                </button>

                {/* Hide Panel Button */}
                <button
                  onClick={() => setIsAnimationPanelOpen(false)}
                  style={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: "rgba(239, 68, 68, 0.2)",
                    color: "#ef4444",
                    border: "1px solid rgba(239, 68, 68, 0.3)",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s",
                  }}
                  title="Hide Panel"
                >
                  ✕
                </button>
              </div>
            )}

            {/* Desktop Playback Controls */}
            {!isMobile && animations.length > 0 && selectedAnimation && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <button
                  onClick={restartAnimation}
                  style={{
                    width: "38px",
                    height: "38px",
                    backgroundColor: "#374151",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s",
                  }}
                  title="Restart"
                  onMouseEnter={(e) => (e.target.style.backgroundColor = "#4b5563")}
                  onMouseLeave={(e) => (e.target.style.backgroundColor = "#374151")}
                >
                  ↻
                </button>

                <button
                  onClick={() => setIsPlaying(!isPlaying)}
                  style={{
                    width: "44px",
                    height: "44px",
                    backgroundColor: isPlaying ? "#10b981" : "#3b82f6",
                    color: "#fff",
                    border: "none",
                    borderRadius: "50%",
                    cursor: "pointer",
                    fontSize: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s",
                    boxShadow: "0 2px 12px rgba(59, 130, 246, 0.4)",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "scale(1.05)"
                    e.target.style.backgroundColor = isPlaying ? "#059669" : "#2563eb"
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "scale(1)"
                    e.target.style.backgroundColor = isPlaying ? "#10b981" : "#3b82f6"
                  }}
                >
                  {isPlaying ? "⏸" : "▶"}
                </button>

                {/* Speed Button - Single Cycling Button */}
                <button
                  onClick={() => {
                    const speeds = [1, 2, 5, 10]
                    const currentIndex = speeds.indexOf(animationSpeed)
                    const nextIndex = (currentIndex + 1) % speeds.length
                    setAnimationSpeed(speeds[nextIndex])
                  }}
                  style={{
                    padding: "6px 12px",
                    backgroundColor: "#3b82f6",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "11px",
                    fontWeight: 600,
                    transition: "all 0.2s",
                    minWidth: "45px",
                    marginLeft: "4px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#2563eb"
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#3b82f6"
                  }}
                  title="Click to cycle speed (1x → 2x → 5x → 10x)"
                >
                  {animationSpeed}x
                </button>

                {/* Camera Animation Toggle Button */}
                <button
                  onClick={() => {
                    if (isRecordingCameraAnimation) {
                      // Stop recording
                      setIsRecordingCameraAnimation(false)
                    } else if (cameraKeyframes.length > 0) {
                      // Clear keyframes
                      if (confirm("Clear camera animation?")) {
                        setCameraKeyframes([])
                        cameraKeyframesRef.current = []
                      }
                    } else {
                      // Start recording
                      setIsRecordingCameraAnimation(true)
                    }
                  }}
                  style={{
                    padding: "6px 12px",
                    backgroundColor: isRecordingCameraAnimation
                      ? "#ef4444"
                      : cameraKeyframes.length > 0
                        ? "#8b5cf6"
                        : "#6b7280",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "11px",
                    fontWeight: 600,
                    transition: "all 0.2s",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                  onMouseEnter={(e) => {
                    if (isRecordingCameraAnimation) {
                      e.target.style.backgroundColor = "#dc2626"
                    } else if (cameraKeyframes.length > 0) {
                      e.target.style.backgroundColor = "#7c3aed"
                    } else {
                      e.target.style.backgroundColor = "#4b5563"
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (isRecordingCameraAnimation) {
                      e.target.style.backgroundColor = "#ef4444"
                    } else if (cameraKeyframes.length > 0) {
                      e.target.style.backgroundColor = "#8b5cf6"
                    } else {
                      e.target.style.backgroundColor = "#6b7280"
                    }
                  }}
                  title={
                    isRecordingCameraAnimation
                      ? "Stop Recording Camera Animation"
                      : cameraKeyframes.length > 0
                        ? `${cameraKeyframes.length} Camera Keyframes (Click to clear)`
                        : "Start Camera Animation Recording"
                  }
                >
                  🎬
                  {cameraKeyframes.length > 0 && (
                    <span style={{ fontSize: "9px", opacity: 0.9 }}>
                      {cameraKeyframes.length}
                    </span>
                  )}
                  {isRecordingCameraAnimation && (
                    <span
                      style={{
                        width: "5px",
                        height: "5px",
                        backgroundColor: "#fff",
                        borderRadius: "50%",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  )}
                </button>
              </div>
            )}

            {/* Divider - Desktop only */}
            {!isMobile && animations.length > 0 && selectedAnimation && (
              <div
                style={{
                  width: "1px",
                  height: "32px",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                }}
              />
            )}

            {/* Desktop Capture Buttons */}
            {!isMobile && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  flex: 1,
                  justifyContent:
                    animations.length > 0 && selectedAnimation
                      ? "flex-start"
                      : "center",
                }}
              >
                <button
                  onClick={captureScreenshot}
                  style={{
                    padding: "8px 18px",
                    backgroundColor: "#3b82f6",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "12px",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    transition: "all 0.2s",
                    boxShadow: "0 2px 8px rgba(59, 130, 246, 0.3)",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#2563eb"
                    e.target.style.transform = "translateY(-1px)"
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#3b82f6"
                    e.target.style.transform = "translateY(0)"
                  }}
                >
                  <span>📸</span>
                  <span>Screenshot</span>
                </button>

                {/* Recording Mode Toggle - Desktop */}
                <button
                  onClick={() =>
                    setRecordingMode(
                      recordingMode === "real-time" ? "high-quality" : "real-time"
                    )
                  }
                  disabled={isRecording || isRendering}
                  style={{
                    padding: "8px 14px",
                    backgroundColor:
                      recordingMode === "high-quality" ? "#10b981" : "#6366f1",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: isRecording || isRendering ? "not-allowed" : "pointer",
                    fontSize: "11px",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    transition: "all 0.2s",
                    opacity: isRecording || isRendering ? 0.5 : 1,
                  }}
                  title={
                    recordingMode === "high-quality"
                      ? "High Quality Mode (Frame-by-frame, Custom FPS & duration)"
                      : "Real-time Mode (Faster, May lag on slow devices)"
                  }
                  onMouseEnter={(e) => {
                    if (!isRecording && !isRendering) {
                      e.target.style.transform = "translateY(-1px)"
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)"
                  }}
                >
                  <span>{recordingMode === "high-quality" ? "⚡" : "⏱️"}</span>
                  <span>{recordingMode === "high-quality" ? "HQ" : "RT"}</span>
                </button>

                <button
                  onClick={
                    isRendering
                      ? cancelRendering
                      : isRecording
                        ? stopRecording
                        : startRecording
                  }
                  disabled={
                    (!selectedAnimation &&
                      cameraKeyframes.length < 2 &&
                      !isRecording &&
                      !isRendering) ||
                    transparentBackground
                  }
                  style={{
                    padding: "8px 18px",
                    backgroundColor: isRendering
                      ? "#8b5cf6"
                      : isRecording
                        ? "#ef4444"
                        : (!selectedAnimation && cameraKeyframes.length < 2) ||
                            transparentBackground
                          ? "#4b5563"
                          : "#f59e0b",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor:
                      (!selectedAnimation &&
                        cameraKeyframes.length < 2 &&
                        !isRecording &&
                        !isRendering) ||
                      transparentBackground
                        ? "not-allowed"
                        : "pointer",
                    fontSize: "12px",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    transition: "all 0.2s",
                    opacity:
                      (!selectedAnimation &&
                        cameraKeyframes.length < 2 &&
                        !isRecording &&
                        !isRendering) ||
                      transparentBackground
                        ? 0.5
                        : 1,
                    boxShadow: isRendering
                      ? "0 2px 8px rgba(139, 92, 246, 0.4)"
                      : isRecording
                        ? "0 2px 8px rgba(239, 68, 68, 0.4)"
                        : !selectedAnimation && cameraKeyframes.length < 2
                          ? "none"
                          : "0 2px 8px rgba(245, 158, 11, 0.3)",
                  }}
                  onMouseEnter={(e) => {
                    if (
                      selectedAnimation ||
                      cameraKeyframes.length >= 2 ||
                      isRecording ||
                      isRendering
                    ) {
                      e.target.style.transform = "translateY(-1px)"
                      if (isRendering) {
                        e.target.style.backgroundColor = "#7c3aed"
                      } else if (isRecording) {
                        e.target.style.backgroundColor = "#dc2626"
                      } else {
                        e.target.style.backgroundColor = "#ea580c"
                      }
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)"
                    if (isRendering) {
                      e.target.style.backgroundColor = "#8b5cf6"
                    } else if (isRecording) {
                      e.target.style.backgroundColor = "#ef4444"
                    } else if (selectedAnimation) {
                      e.target.style.backgroundColor = "#f59e0b"
                    }
                  }}
                  title={
                    transparentBackground
                      ? "Video recording disabled - WebM doesn't support transparent background"
                      : isRendering
                        ? "Cancel Rendering"
                        : isRecording
                          ? "Stop Recording"
                          : "Record Animation"
                  }
                >
                  <span>{isRendering ? "⏸" : isRecording ? "⏹" : "🎥"}</span>
                  <span>
                    {isRendering ? "Cancel" : isRecording ? "Stop" : "Record"}
                  </span>
                </button>

                {/* Recording Indicator - Desktop only */}
                {isRecording && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      fontSize: "11px",
                      color: "#fca5a5",
                    }}
                  >
                    <span
                      style={{
                        width: "6px",
                        height: "6px",
                        backgroundColor: "#ef4444",
                        borderRadius: "50%",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                    <span>Recording...</span>
                  </div>
                )}
              </div>
            )}

            {/* Close Button - Desktop only */}
            {!isMobile && (
              <button
                onClick={() => setIsAnimationPanelOpen(false)}
                style={{
                  width: "28px",
                  height: "28px",
                  backgroundColor: "rgba(239, 68, 68, 0.2)",
                  color: "#ef4444",
                  border: "1px solid rgba(239, 68, 68, 0.3)",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "rgba(239, 68, 68, 0.3)")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "rgba(239, 68, 68, 0.2)")
                }
              >
                ✕
              </button>
            )}
          </div>

          {/* Progress Bar dengan Camera Keyframe Markers */}
          {animations.length > 0 && selectedAnimation && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <div
                style={{
                  flex: 1,
                  height: "6px",
                  backgroundColor: "#2d2d32",
                  borderRadius: "3px",
                  overflow: "hidden",
                  cursor: "pointer",
                  position: "relative",
                }}
                onClick={(e) => {
                  if (isDraggingProgressRef.current) return // Ignore click if was dragging
                  const rect = e.currentTarget.getBoundingClientRect()
                  const clickX = e.clientX - rect.left
                  const progress = (clickX / rect.width) * 100
                  seekAnimation(Math.max(0, Math.min(100, progress)))
                }}
                onMouseDown={(e) => {
                  isDraggingProgressRef.current = true
                  const rect = e.currentTarget.getBoundingClientRect()

                  let rafId = null

                  const updateProgress = (clientX) => {
                    const moveX = clientX - rect.left
                    const progress = Math.max(0, Math.min(100, (moveX / rect.width) * 100))

                    // Update animation time directly (smooth viewport update)
                    if (currentActionRef?.current && animationDuration) {
                      const targetTime = (progress / 100) * animationDuration
                      currentActionRef.current.time = targetTime
                    }

                    // Update state for visual feedback (throttled by RAF)
                    if (seekAnimation) {
                      seekAnimation(progress, true)
                    }
                  }

                  const handleMouseMove = (moveEvent) => {
                    // Use RAF to throttle to 60fps max
                    if (rafId) return // Skip if RAF already pending

                    rafId = requestAnimationFrame(() => {
                      updateProgress(moveEvent.clientX)
                      rafId = null // Allow next RAF
                    })
                  }

                  const handleMouseUp = () => {
                    if (rafId) {
                      cancelAnimationFrame(rafId)
                      rafId = null
                    }
                    document.removeEventListener("mousemove", handleMouseMove)
                    document.removeEventListener("mouseup", handleMouseUp)

                    // Small delay before allowing clicks again
                    setTimeout(() => {
                      isDraggingProgressRef.current = false
                    }, 50)
                  }

                  document.addEventListener("mousemove", handleMouseMove)
                  document.addEventListener("mouseup", handleMouseUp)

                  // Handle initial click position immediately
                  updateProgress(e.clientX)
                }}
              >
                <div
                  style={{
                    width: `${animationProgress}%`,
                    height: "100%",
                    backgroundColor: isPlaying ? "#3b82f6" : "#6b7280",
                    borderRadius: "3px",
                    transition: "background-color 0.2s",
                    pointerEvents: "none",
                  }}
                />

                {/* Camera Keyframe Markers */}
                {cameraKeyframes.length > 0 &&
                  cameraKeyframes.map((keyframe) => {
                    const maxTime = Math.max(
                      animationDuration || cameraAnimationDuration,
                      cameraAnimationDuration
                    )
                    const position = (keyframe.time / maxTime) * 100

                    return (
                      <div
                        key={keyframe.id}
                        style={{
                          position: "absolute",
                          left: `${position}%`,
                          top: "50%",
                          transform:
                            selectedCameraKeyframe === keyframe.id
                              ? "translate(-50%, -50%) rotate(45deg) scale(1.4)"
                              : "translate(-50%, -50%) rotate(45deg)",
                          width: "10px",
                          height: "10px",
                          backgroundColor:
                            selectedCameraKeyframe === keyframe.id
                              ? "#f59e0b"
                              : "#8b5cf6",
                          border:
                            selectedCameraKeyframe === keyframe.id
                              ? "2px solid #fbbf24"
                              : "2px solid #a78bfa",
                          borderRadius: "2px",
                          pointerEvents: "auto",
                          cursor: "grab",
                          zIndex: selectedCameraKeyframe === keyframe.id ? 3 : 2,
                          boxShadow:
                            selectedCameraKeyframe === keyframe.id
                              ? "0 0 12px rgba(245, 158, 11, 0.9)"
                              : "0 0 8px rgba(139, 92, 246, 0.6)",
                          transition: "all 0.2s ease",
                          animation:
                            flashKeyframe === keyframe.id
                              ? selectedCameraKeyframe === keyframe.id
                                ? "updatePulse 0.6s ease-in-out"
                                : "flashPulse 0.6s ease-in-out"
                              : "none",
                        }}
                        title={`Camera Keyframe at ${keyframe.time.toFixed(2)}s - Click to select, Drag to adjust timing`}
                        onClick={(e) => {
                          e.stopPropagation()

                          // Select keyframe
                          setSelectedCameraKeyframe(keyframe.id)

                          // Jump to keyframe position
                          const progress = (keyframe.time / maxTime) * 100
                          seekAnimation(progress)

                          // Also jump camera to keyframe
                          const camera = window.MAIN_CAMERA || cameraRef?.current
                          const controls = window.ORBIT_CONTROLS || controlsRef?.current
                          
                          if (camera && controls) {
                            camera.position.set(
                              keyframe.position.x,
                              keyframe.position.y,
                              keyframe.position.z
                            )
                            camera.quaternion.set(
                              keyframe.quaternion.x,
                              keyframe.quaternion.y,
                              keyframe.quaternion.z,
                              keyframe.quaternion.w
                            )
                            controls.target.set(
                              keyframe.target.x,
                              keyframe.target.y,
                              keyframe.target.z
                            )
                            camera.fov = keyframe.fov
                            camera.updateProjectionMatrix()
                            controls.update()
                          }
                        }}
                        onMouseDown={(e) => {
                          e.stopPropagation()
                          e.preventDefault()

                          // Select this keyframe
                          setSelectedCameraKeyframe(keyframe.id)

                          const timelineBar = e.currentTarget.parentElement
                          const rect = timelineBar.getBoundingClientRect()
                          const isDragging = { value: true }

                          const handleMouseMove = (moveEvent) => {
                            if (!isDragging.value) return

                            const moveX = moveEvent.clientX - rect.left
                            const newProgress = Math.max(
                              0,
                              Math.min(100, (moveX / rect.width) * 100)
                            )
                            const newTime = (newProgress / 100) * maxTime

                            // Update keyframe time
                            const updated = cameraKeyframes
                              .map((kf) =>
                                kf.id === keyframe.id ? { ...kf, time: newTime } : kf
                              )
                              .sort((a, b) => a.time - b.time)

                            setCameraKeyframes(updated)
                            cameraKeyframesRef.current = updated

                            // Update timeline position
                            seekAnimation(newProgress)
                          }

                          const handleMouseUp = () => {
                            isDragging.value = false
                            document.removeEventListener("mousemove", handleMouseMove)
                            document.removeEventListener("mouseup", handleMouseUp)
                            if (e.currentTarget && e.currentTarget.style) {
                              e.currentTarget.style.cursor = "grab"
                            }
                          }

                          document.addEventListener("mousemove", handleMouseMove)
                          document.addEventListener("mouseup", handleMouseUp)
                          e.currentTarget.style.cursor = "grabbing"
                        }}
                        onMouseEnter={(e) => {
                          const isSelected = selectedCameraKeyframe === keyframe.id
                          e.currentTarget.style.transform = isSelected
                            ? "translate(-50%, -50%) rotate(45deg) scale(1.5)"
                            : "translate(-50%, -50%) rotate(45deg) scale(1.3)"
                          e.currentTarget.style.boxShadow = isSelected
                            ? "0 0 16px rgba(245, 158, 11, 1)"
                            : "0 0 12px rgba(139, 92, 246, 0.9)"
                        }}
                        onMouseLeave={(e) => {
                          const isSelected = selectedCameraKeyframe === keyframe.id
                          e.currentTarget.style.transform = isSelected
                            ? "translate(-50%, -50%) rotate(45deg) scale(1.4)"
                            : "translate(-50%, -50%) rotate(45deg) scale(1)"
                          e.currentTarget.style.boxShadow = isSelected
                            ? "0 0 12px rgba(245, 158, 11, 0.9)"
                            : "0 0 8px rgba(139, 92, 246, 0.6)"
                        }}
                      />
                    )
                  })}
              </div>
              <div
                style={{
                  fontSize: "10px",
                  color: "#6b7280",
                  minWidth: "45px",
                  textAlign: "right",
                  fontVariantNumeric: "tabular-nums",
                }}
              >
                {Math.floor(animationProgress)}%
              </div>
            </div>
          )}

          {/* Camera Animation - Ultra Compact Inline */}
          {(cameraKeyframes.length > 0 || isRecordingCameraAnimation) && (
            <div
              style={{
                marginTop: "12px",
                padding: "8px 12px",
                backgroundColor: "rgba(139, 92, 246, 0.08)",
                borderRadius: "8px",
                border: "1px solid rgba(139, 92, 246, 0.15)",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "11px",
              }}
            >
              {/* Label with Status */}
              <span
                style={{
                  fontWeight: 600,
                  color: selectedCameraKeyframe ? "#f59e0b" : "#a78bfa",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  fontSize: "11px",
                }}
              >
                🎬
                {selectedCameraKeyframe ? (
                  <span>
                    #
                    {cameraKeyframes.findIndex(
                      (kf) => kf.id === selectedCameraKeyframe
                    ) + 1}
                  </span>
                ) : (
                  <span>{cameraKeyframes.length}</span>
                )}
                {isRecordingCameraAnimation && (
                  <span
                    style={{
                      width: "5px",
                      height: "5px",
                      backgroundColor: "#ef4444",
                      borderRadius: "50%",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  />
                )}
              </span>

              {/* Record/Stop Button */}
              <button
                onClick={() => {
                  setIsRecordingCameraAnimation(!isRecordingCameraAnimation)
                }}
                style={{
                  padding: "4px 10px",
                  backgroundColor: isRecordingCameraAnimation
                    ? "rgba(239, 68, 68, 0.8)"
                    : "rgba(139, 92, 246, 0.8)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "11px",
                  fontWeight: 600,
                }}
              >
                {isRecordingCameraAnimation ? "⏹" : "🔴"}
              </button>

              {/* Capture Button - Only when recording */}
              {isRecordingCameraAnimation && (
                <button
                  onClick={() => {
                    const time = animationProgress
                      ? (animationProgress / 100) * (animationDuration || cameraAnimationDuration)
                      : cameraKeyframes.length * 2
                    addCameraKeyframe(time)
                  }}
                  style={{
                    padding: "4px 10px",
                    background:
                      "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "11px",
                    fontWeight: 600,
                  }}
                >
                  📍
                </button>
              )}

              {/* Update Keyframe Button - When keyframe is selected */}
              {selectedCameraKeyframe && !isRecordingCameraAnimation && (
                <>
                  <button
                    onClick={() => {
                      updateCameraKeyframe(selectedCameraKeyframe)
                    }}
                    style={{
                      padding: "4px 10px",
                      background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontSize: "11px",
                      fontWeight: 600,
                    }}
                    title="Update selected keyframe with current camera position"
                  >
                    🔄
                  </button>
                  <button
                    onClick={() => {
                      deleteCameraKeyframe(selectedCameraKeyframe)
                    }}
                    style={{
                      padding: "4px 8px",
                      backgroundColor: "rgba(239, 68, 68, 0.3)",
                      color: "#ef4444",
                      border: "none",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontSize: "11px",
                    }}
                    title="Delete selected keyframe"
                  >
                    🗑️
                  </button>
                  <button
                    onClick={() => {
                      setSelectedCameraKeyframe(null)
                    }}
                    style={{
                      padding: "4px 8px",
                      backgroundColor: "rgba(100, 100, 100, 0.3)",
                      color: "#999",
                      border: "none",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontSize: "10px",
                    }}
                    title="Deselect keyframe"
                  >
                    ✕
                  </button>
                </>
              )}

              {/* Interpolation Selector */}
              <select
                value={cameraInterpolationType}
                onChange={(e) => setCameraInterpolationType(e.target.value)}
                style={{
                  padding: "4px 8px",
                  backgroundColor: "#1e1e23",
                  color: "#fff",
                  border: "1px solid rgba(139, 92, 246, 0.3)",
                  borderRadius: "6px",
                  fontSize: "10px",
                  cursor: "pointer",
                }}
              >
                <option value="linear">Linear</option>
                <option value="smooth">Smooth</option>
                <option value="cubic">Cinema</option>
              </select>

              {/* Divider */}
              <div
                style={{
                  width: "1px",
                  height: "20px",
                  backgroundColor: "rgba(139, 92, 246, 0.3)",
                }}
              />

              {/* Quick Actions */}
              <button
                onClick={() => {
                  const data = {
                    keyframes: cameraKeyframes,
                    interpolationType: cameraInterpolationType,
                  }
                  const blob = new Blob([JSON.stringify(data, null, 2)], {
                    type: "application/json",
                  })
                  const url = URL.createObjectURL(blob)
                  const a = document.createElement("a")
                  a.href = url
                  a.download = "camera-animation.json"
                  a.click()
                  URL.revokeObjectURL(url)

                  // Show toast notification
                  showCameraAnimToast(`${cameraKeyframes.length} keyframes exported`, "success")
                }}
                disabled={cameraKeyframes.length === 0}
                style={{
                  padding: "4px 8px",
                  backgroundColor: "transparent",
                  color: cameraKeyframes.length > 0 ? "#10b981" : "#666",
                  border: "none",
                  borderRadius: "6px",
                  cursor: cameraKeyframes.length > 0 ? "pointer" : "not-allowed",
                  fontSize: "11px",
                  opacity: cameraKeyframes.length > 0 ? 1 : 0.3,
                }}
                title="Export"
              >
                💾
              </button>

              <button
                onClick={() => {
                  const input = document.createElement("input")
                  input.type = "file"
                  input.accept = ".json"
                  input.onchange = (e) => {
                    const file = e.target.files[0]
                    if (file) {
                      const reader = new FileReader()
                      reader.onload = (event) => {
                        try {
                          const data = JSON.parse(event.target.result)
                          if (data.keyframes && Array.isArray(data.keyframes)) {
                            setCameraKeyframes(data.keyframes)
                            cameraKeyframesRef.current = data.keyframes
                            if (data.interpolationType) {
                              setCameraInterpolationType(data.interpolationType)
                            }

                            // Show success toast
                            showCameraAnimToast(
                              `${data.keyframes.length} keyframes imported successfully`,
                              "success"
                            )
                          }
                        } catch (err) {
                          console.error("Error importing:", err)
                          showCameraAnimToast("Failed to import animation", "delete")
                        }
                      }
                      reader.readAsText(file)
                    }
                  }
                  input.click()
                }}
                style={{
                  padding: "4px 8px",
                  backgroundColor: "transparent",
                  color: "#3b82f6",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "11px",
                }}
                title="Import"
              >
                📂
              </button>

              <button
                onClick={() => {
                  if (confirm("Clear all keyframes?")) {
                    const count = cameraKeyframes.length
                    setCameraKeyframes([])
                    cameraKeyframesRef.current = []
                    setSelectedCameraKeyframe(null)

                    // Show toast notification
                    showCameraAnimToast(`${count} keyframes cleared`, "delete")
                  }
                }}
                disabled={cameraKeyframes.length === 0}
                style={{
                  padding: "4px 8px",
                  backgroundColor: "transparent",
                  color: cameraKeyframes.length > 0 ? "#ef4444" : "#666",
                  border: "none",
                  borderRadius: "6px",
                  cursor: cameraKeyframes.length > 0 ? "pointer" : "not-allowed",
                  fontSize: "11px",
                  opacity: cameraKeyframes.length > 0 ? 1 : 0.3,
                }}
                title="Clear All"
              >
                🗑️
              </button>
            </div>
          )}
        </div>
      )}

      {/* Toggle Control Panel Button - Bottom Center (when collapsed) */}
      {showPanel && viewportReady && !isAnimationPanelOpen && (
        <button
          onClick={() => setIsAnimationPanelOpen(true)}
          style={{
            position: "absolute",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 15,
            padding: "12px 24px",
            background:
              "linear-gradient(135deg, rgba(59, 130, 246, 0.82), rgba(37, 99, 235, 0.88))",
            backdropFilter: "blur(20px) saturate(190%)",
            WebkitBackdropFilter: "blur(20px) saturate(190%)",
            color: "#fff",
            border: "0.5px solid rgba(255, 255, 255, 0.22)",
            borderTop: "0.5px solid rgba(255, 255, 255, 0.3)",
            borderRadius: "12px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: 600,
            boxShadow:
              "0 4px 12px rgba(0, 0, 0, 0.18), 0 8px 24px rgba(0, 0, 0, 0.12)",
            transition: "all 0.32s cubic-bezier(0.32, 0.72, 0, 1)",
            fontFamily: "system-ui, -apple-system, sans-serif",
          }}
          onMouseEnter={(e) => {
            e.target.style.background =
              "linear-gradient(135deg, rgba(37, 99, 235, 0.88), rgba(29, 78, 216, 0.92))"
            e.target.style.transform = "translateX(-50%) translateY(-2px) scale(1.02)"
          }}
          onMouseLeave={(e) => {
            e.target.style.background =
              "linear-gradient(135deg, rgba(59, 130, 246, 0.82), rgba(37, 99, 235, 0.88))"
            e.target.style.transform = "translateX(-50%) translateY(0) scale(1)"
          }}
        >
          🎬 {animations.length > 0 ? "Controls" : "Capture Tools"}
        </button>
      )}

      {/* Status indicator when panel is hidden */}
      {!showPanel && isReady && !modelFile && !modelUrlProp && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            color: "#fff",
            fontFamily: "system-ui, -apple-system, sans-serif",
            zIndex: 5,
            padding: "24px",
            backgroundColor: "rgba(20, 20, 25, 0.8)",
            borderRadius: "12px",
          }}
        >
          <p style={{ fontSize: "16px", margin: 0 }}>
            Upload model in Framer properties panel
          </p>
        </div>
      )}
    </>
  )
}
